// extracted by mini-css-extract-plugin
export var a_container = "faq-module--a_container--vzLvf";
export var a_panel = "faq-module--a_panel--f0zu-";
export var active = "faq-module--active--uGKQg";
export var faq_container = "faq-module--faq_container--by42t";
export var sectionHeader = "faq-module--sectionHeader--T+TF5";
export var sectionHeaderInner = "faq-module--sectionHeaderInner---jNYY";
export var sectionHeaderLogo = "faq-module--sectionHeaderLogo--0YHOu";